// Field configuration for Product form
import { FieldConfig, FieldRules, FieldRulesConfig } from '@/types/form'
import { ProductModel } from '@/types/model/Product'

// Re-using ProductFormData, but might need to ensure all fields are covered or strict
// For now, we'll base it on ProductFormData from the model
export type ProductFormState = ProductModel.ProductFormData

export const productFields: (keyof ProductFormState)[] = [
  'name',
  'slug',
  'summary',
  'tags',
  'discount',
  'discountType',
  'description',
  'deliveryReturnPolicy',
  'category',
  'brand',
  'status',
  'metaTitle',
  'metaDescription',
  'metaKeywords',
  'thumbnailId',
  'thumbnailUrl',
  'attributes',
  'variations',
]

interface ProductFieldsConfig extends FieldConfig<{
  name: FieldRules<ProductFormState['name']>
  slug: FieldRules<ProductFormState['slug']>
  summary: FieldRules<ProductFormState['summary']>
  tags: FieldRules<ProductFormState['tags']>
  discount: FieldRules<ProductFormState['discount']>
  discountType: FieldRules<ProductFormState['discountType']>
  description: FieldRules<ProductFormState['description']>
  deliveryReturnPolicy: FieldRules<ProductFormState['deliveryReturnPolicy']>
  category: FieldRules<ProductFormState['category']>
  brand: FieldRules<ProductFormState['brand']>
  status: FieldRules<ProductFormState['status']>
  metaTitle: FieldRules<ProductFormState['metaTitle']>
  metaDescription: FieldRules<ProductFormState['metaDescription']>
  metaKeywords: FieldRules<ProductFormState['metaKeywords']>
  thumbnailId: FieldRules<ProductFormState['thumbnailId']>
  thumbnailUrl: FieldRules<ProductFormState['thumbnailUrl']>
  attributes: FieldRules<ProductFormState['attributes']>
  variations: FieldRules<ProductFormState['variations']>
}> {}

interface ProductFieldsConfigProps extends FieldRulesConfig<ProductFormState> {}

export function productFieldsConfig(_props: ProductFieldsConfigProps): ProductFieldsConfig {
  return {
    fields: {
      name: {
        rules: {
          required: 'Product name is required',
        },
      },
      slug: {
        rules: {},
      },
      summary: {
        rules: {},
      },
      tags: {
        rules: {},
      },
      discount: {
        rules: {},
      },
      discountType: {
        rules: {},
      },
      description: {
        rules: {
          required: 'Description is required',
          minLength: {
            value: 10,
            message: 'Description must be at least 10 characters',
          },
        },
      },
      deliveryReturnPolicy: {
        rules: {
          required: 'Delivery & Return Policy is required',
          minLength: {
            value: 10,
            message: 'Policy must be at least 10 characters',
          },
        },
      },
      category: {
        rules: {
          required: 'Category is required',
        },
      },
      brand: {
        rules: {},
      },
      status: {
        rules: {
          required: 'Status is required',
        },
      },
      metaTitle: {
        rules: {},
      },
      metaDescription: {
        rules: {},
      },
      thumbnailId: {
        rules: {},
      },
      thumbnailUrl: {
        rules: {},
      },
      metaKeywords: {
        rules: {},
      },
      attributes: {
        rules: {},
      },
      variations: {
        rules: {},
      },
    },
  }
}
